// extracted by mini-css-extract-plugin
export default {"localizedValueInput":"LocalizedValueInput_localizedValueInput__UpY4Y","title":"LocalizedValueInput_title__+ZUvA","list":"LocalizedValueInput_list__Vjz28"};